app.controller('caseManagementController', async function ($rootScope, $filter, $scope, safeApply, systemService, caseManagementService) {

  $scope.refreshing = true

  const _defaultFooter = $rootScope.footer_message

  function updateFooterStats() {
    const records = applyGlobalFilters($scope.caseData || [])
    const withDate = records.filter(r => !!r.hearing_date)
    const withoutDate = records.length - withDate.length

    let range = '—'
    if (withDate.length > 0) {
      const dates = withDate.map(r => moment(r.hearing_date))
      const min = moment.min(dates).format('MMM D, YYYY')
      const max = moment.max(dates).format('MMM D, YYYY')
      range = (min === max) ? min : `${min} - ${max}`
    }

    const fmt = (n) => n.toLocaleString('en-US')
    $rootScope.footer_message =
      `${range}` +
      `&nbsp;&nbsp;|&nbsp;&nbsp;Properties with Hearing Date: ${fmt(withDate.length)}` +
      `&nbsp;&nbsp;|&nbsp;&nbsp;Properties without Hearing Date: ${fmt(withoutDate)}`
    safeApply($scope)
  }

  $scope.$on('$destroy', () => {
    $rootScope.footer_message = _defaultFooter
  })

  $scope.currentCounty = null
  $scope.currentCadAgent = null
  $scope.tableLoading = true

  // Global "Don't Show PTIO=0" toggle — hides properties we are not authorized on
  // (auth_ptio falsy). Shared across calendar, day table, and export.
  $scope.hidePtioZero = false

  // Apply the global PTIO filter to any record set.
  function applyGlobalFilters(records) {
    if (!$scope.hidePtioZero) return records
    return records.filter(r => !!r.auth_ptio)
  }

  $scope.toggleHidePtioZero = () => {
    $scope.hidePtioZero = !$scope.hidePtioZero
    buildCalendarMonths()
    // If a day is open, rebuild its filtered record set + dropdown counts so the table reflects the toggle.
    if ($scope.selectedDay) {
      buildSelectedDayRecords($scope.selectedDay.key)
    }
    safeApply($scope)
  }

  $scope.setCadAgent = (agent) => {
    $scope.currentCadAgent = agent
    buildCalendarMonths()
    safeApply($scope)
  }

  $scope.refreshing = false
  $scope.refreshCaseData = async () => {
    if ($scope.refreshing) return
    $scope.refreshing = true
    safeApply($scope)
    const payload = { tax_year: $scope.tax_year }
    if ($scope.currentCounty && $scope.currentCounty.cad_code) payload.cad_code = $scope.currentCounty.cad_code
    const [caseDataResults, countyListResults] = await Promise.all([
      caseManagementService.loadCaseData(payload),
      caseManagementService.loadCaseDataCounties({ tax_year: $scope.tax_year }),
    ])
    $scope.caseData = caseDataResults.data.data
    $scope.countyList = countyListResults.data.data
    buildCalendarMonths()
    $scope.refreshing = false
    safeApply($scope)
  }

  $scope.setCounty = async (county) => {
    $scope.currentCounty = county
    const payload = { tax_year: $scope.tax_year }
    if (county.cad_code) payload.cad_code = county.cad_code
    let caseDataResults = await caseManagementService.loadCaseData(payload)
    $scope.caseData = caseDataResults.data.data
    buildCalendarMonths()
    $scope.clearSelectedDay()
    console.log('$scope.caseData :>> ', $scope.caseData)
    safeApply($scope)
  }

  $scope.selectedDay = null
  $scope.selectedDayRecords = []

  // Build the day's record set and its filter dropdowns/counts for the given day key.
  // Shared by selectDay() and the global PTIO toggle so counts stay in sync.
  function buildSelectedDayRecords(dayKey) {
    $scope.selectedDayRecords = applyGlobalFilters($scope.caseData || [])
      .filter(r => r.hearing_date && moment(r.hearing_date).format('YYYY-MM-DD') === dayKey)
      .map(r => Object.assign({}, r, {
        hearing_date: r.hearing_date ? moment(r.hearing_date).toDate() : null,
      }))

    // Build dedup'd county list for the day filter dropdown
    const seen = new Map()
    $scope.selectedDayRecords.forEach(r => {
      if (!seen.has(r.cad_code)) {
        seen.set(r.cad_code, { county_name: r.county_name, cad_code: r.cad_code })
      }
    })
    $scope.dayCountyList = Array.from(seen.values()).sort((a, b) => (a.county_name || '').localeCompare(b.county_name || ''))
    $scope.dayCountyFilter = null

    // Build agent list — every CAD agent + an "Unassigned" entry — with counts from this day's records
    const dayAgentCounts = {}
    let unassignedCount = 0
    $scope.selectedDayRecords.forEach(r => {
      if (r.agent) dayAgentCounts[r.agent] = (dayAgentCounts[r.agent] || 0) + 1
      else unassignedCount++
    })
    $scope.dayAgentList = [{ id: null, name: 'Unassigned', count: unassignedCount }].concat(
      ($scope.cadAgents || []).map(a => ({ id: a.id, name: a.name, count: dayAgentCounts[a.id] || 0 }))
    )
    $scope.dayAgentFilter = null

    // Build distinct type list with counts
    const typeCounts = {}
    $scope.selectedDayRecords.forEach(r => {
      const key = r.prop_type || '(none)'
      typeCounts[key] = (typeCounts[key] || 0) + 1
    })
    $scope.dayTypeList = Object.keys(typeCounts).sort().map(k => ({
      type: k === '(none)' ? null : k,
      label: k,
      count: typeCounts[k],
    }))
    $scope.dayTypeFilter = null
  }

  $scope.selectDay = (day) => {
    if (!day.inMonth || day.hearingCount === 0) return
    const dayKey = day.date.format('YYYY-MM-DD')
    $scope.selectedDay = {
      key: dayKey,
      label: day.date.format('dddd, MMMM D, YYYY'),
    }
    buildSelectedDayRecords(dayKey)
    safeApply($scope)
  }

  $scope.setDayCountyFilter = (county) => {
    $scope.dayCountyFilter = county
  }

  $scope.setDayAgentFilter = (agentFilter) => {
    $scope.dayAgentFilter = agentFilter
  }

  $scope.setDayTypeFilter = (typeFilter) => {
    $scope.dayTypeFilter = typeFilter
  }

  $scope.dayRecordsFilter = (rec) => {
    if ($scope.dayCountyFilter && rec.cad_code !== $scope.dayCountyFilter.cad_code) return false
    if ($scope.dayAgentFilter) {
      if ($scope.dayAgentFilter.id === null) {
        if (rec.agent) return false
      } else if (rec.agent !== $scope.dayAgentFilter.id) return false
    }
    if ($scope.dayTypeFilter) {
      const recType = rec.prop_type || null
      if (recType !== $scope.dayTypeFilter.type) return false
    }
    return true
  }

  $scope.clearSelectedDay = () => {
    $scope.selectedDay = null
    $scope.selectedDayRecords = []
    $scope.dayCountyList = []
    $scope.dayCountyFilter = null
    $scope.dayAgentList = []
    $scope.dayAgentFilter = null
    $scope.dayTypeList = []
    $scope.dayTypeFilter = null
  }

  $scope.addHearingDatesModal = { county: null, pastedCodes: '', matched: false }

  $scope.openAddHearingDates = () => {
    $scope.addHearingDatesModal = { county: null, pastedCodes: '', matched: false, bulk: { prop_type: 'RES', hearing_date: null, auth_cad: true } }
    const modal = new bootstrap.Modal(document.getElementById('addHearingDatesModal'))
    modal.show()
  }

  $scope.exportModal = { startDate: null, endDate: null }

  $scope.openExportHearings = () => {
    const records = ($scope.caseData || []).filter(r => !!r.hearing_date)
    let defaultStart = moment().startOf('day')
    let defaultEnd = moment().add(30, 'days').endOf('day')
    if (records.length > 0) {
      const dates = records.map(r => moment(r.hearing_date))
      defaultStart = moment.min(dates).startOf('day')
      defaultEnd = moment.max(dates).endOf('day')
    }
    $scope.exportModal = {
      startDate: defaultStart.format('YYYY-MM-DD'),
      endDate: defaultEnd.format('YYYY-MM-DD'),
    }
    const modal = new bootstrap.Modal(document.getElementById('exportHearingsModal'))
    modal.show()
  }

  function getExportRecords() {
    const m = $scope.exportModal
    if (!m.startDate || !m.endDate) return []
    const start = moment(m.startDate).startOf('day')
    const end = moment(m.endDate).endOf('day')
    return applyGlobalFilters($scope.caseData || []).filter(r => {
      if (!r.hearing_date) return false
      const hd = moment(r.hearing_date)
      return hd.isSameOrAfter(start) && hd.isSameOrBefore(end)
    })
  }

  $scope.exportRecordCount = () => getExportRecords().length

  function csvEscape(val) {
    if (val === null || val === undefined) return ''
    const s = String(val)
    if (/[",\r\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"'
    return s
  }

  // Build the shared CSV string for a set of case records (sorted by hearing date).
  function buildCaseCsv(records) {
    const agentsById = {}
    ;($scope.cadAgents || []).forEach(a => { agentsById[a.id] = a.name })

    const headers = [
      'County', 'CAD Code', 'CAD Account', 'Type', 'Hearing Date', 'Hearing Time',
      'Protest Status', 'Appeal ID', 'Agent', 'Auth PTIO', 'Auth CAD',
      'Conflict', 'Reschedule', 'Source', 'Notes',
    ]
    const rows = records
      .slice()
      .sort((a, b) => {
        // Records without a hearing date sort to the end.
        const av = a.hearing_date ? moment(a.hearing_date).valueOf() : Infinity
        const bv = b.hearing_date ? moment(b.hearing_date).valueOf() : Infinity
        return av - bv
      })
      .map(r => {
        const hd = r.hearing_date ? moment(r.hearing_date) : null
        return [
          r.county_name,
          r.cad_code,
          r.cad_account !== null && r.cad_account !== undefined && r.cad_account !== '' ? `="${String(r.cad_account).replace(/"/g, '""')}"` : '',
          r.prop_type,
          hd ? hd.format('YYYY-MM-DD') : '',
          hd ? hd.format('HH:mm') : '',
          r.protest_status,
          r.appeal_id,
          r.agent ? (agentsById[r.agent] || r.agent) : '',
          r.auth_ptio ? 'Yes' : 'No',
          r.auth_cad ? 'Yes' : 'No',
          r.conflict ? 'Yes' : 'No',
          r.reschedule ? 'Yes' : 'No',
          r.source,
          r.notes,
        ].map(csvEscape).join(',')
      })
    return headers.map(csvEscape).join(',') + '\r\n' + rows.join('\r\n')
  }

  // Trigger a browser download for the given CSV text.
  function downloadCsv(csv, filename) {
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  $scope.exportHearingsCsv = () => {
    const csv = buildCaseCsv(getExportRecords())
    const m = $scope.exportModal
    downloadCsv(csv, `hearings_${m.startDate}_to_${m.endDate}.csv`)

    const modalEl = document.getElementById('exportHearingsModal')
    const modalInstance = bootstrap.Modal.getInstance(modalEl)
    if (modalInstance) modalInstance.hide()
  }

  // Export every case matching a specific auth_ptio / auth_cad combination.
  // Not date-bound and intentionally ignores the global "Don't Show PTIO=0"
  // toggle — these auth-based exports are about surfacing specific mismatch sets.
  function exportByAuthFlags(ptio, cad, fileSlug) {
    const records = ($scope.caseData || []).filter(r => (!!r.auth_ptio === ptio) && (!!r.auth_cad === cad))
    if (records.length === 0) {
      swal.fire({
        title: 'Nothing to Export',
        text: `No cases found where Auth PTIO = ${ptio ? 1 : 0} and Auth CAD = ${cad ? 1 : 0}.`,
        icon: 'info',
        confirmButtonColor: '#3085d6',
      })
      return
    }
    const csv = buildCaseCsv(records)
    const stamp = moment().format('YYYY-MM-DD')
    downloadCsv(csv, `${fileSlug}_${stamp}.csv`)
  }

  // Cases where we are NOT authorized (auth_ptio = 0) AND the county does not
  // show us as authorized (auth_cad = 0).
  $scope.exportUnauthorizedCsv = () => {
    exportByAuthFlags(false, false, 'cases_ptio0_cad0')
  }

  // Cases where we ARE authorized (auth_ptio = 1) but the county does NOT show
  // us as authorized (auth_cad = 0) — an authorization mismatch to resolve.
  $scope.exportPtio1Cad0Csv = () => {
    exportByAuthFlags(true, false, 'cases_ptio1_cad0')
  }

  // Cases where we are NOT authorized (auth_ptio = 0) but the county DOES show
  // us as authorized (auth_cad = 1) — an authorization mismatch to resolve.
  $scope.exportPtio0Cad1Csv = () => {
    exportByAuthFlags(false, true, 'cases_ptio0_cad1')
  }

  $scope.canSubmitAddHearingDates = () => {
    const m = $scope.addHearingDatesModal
    if (!m || !m.matched) return false
    const newRecords = (m.matchedRecords || []).filter(r => !r.existing_id)
    if (newRecords.length === 0) return false
    return newRecords.every(r => !!r.prop_type && !!r.hearing_date)
  }

  $scope.submitAddHearingDates = async () => {
    const m = $scope.addHearingDatesModal
    if (!m.matched) return
    const newRecords = (m.matchedRecords || []).filter(r => !r.existing_id)
    if (newRecords.length === 0) {
      const modalEl = document.getElementById('addHearingDatesModal')
      bootstrap.Modal.getInstance(modalEl).hide()
      return
    }
    const payload = {
      tax_year: $scope.tax_year,
      records: newRecords.map(r => ({
        cad_code: r.cad_code,
        cad_account: r.cad_account,
        appeal_id: r.appeal_id,
        prop_type: r.prop_type,
        hearing_date: r.hearing_date ? moment(r.hearing_date).format('YYYY-MM-DD HH:mm:ss') : null,
        auth_cad: r.auth_cad,
        source: r.source,
      })),
    }
    const result = await caseManagementService.addCaseManagementRecords(payload)
    if (result.data.success) {
      const modalEl = document.getElementById('addHearingDatesModal')
      bootstrap.Modal.getInstance(modalEl).hide()
      // Reload caseData + counties so the calendar reflects the new rows
      const [caseDataResults, countyListResults] = await Promise.all([
        caseManagementService.loadCaseData({ tax_year: $scope.tax_year }),
        caseManagementService.loadCaseDataCounties({ tax_year: $scope.tax_year }),
      ])
      $scope.caseData = caseDataResults.data.data
      $scope.countyList = countyListResults.data.data
      buildCalendarMonths()
      safeApply($scope)
    } else {
      console.log('addCaseManagementRecords failed :>> ', result.data.error)
    }
  }

  $scope.caseSearch = { term: '', results: [] }

  $scope.runCaseSearch = () => {
    const raw = ($scope.caseSearch.term || '').trim()
    if (raw.length < 2) {
      $scope.caseSearch.results = []
      return
    }
    const term = raw.toLowerCase()
    const isNumeric = /^\d+$/.test(raw)
    $scope.caseSearch.results = ($scope.caseData || []).filter(r => {
      if (r.cad_account && String(r.cad_account).toLowerCase().includes(term)) return true
      if (isNumeric && r.appeal_id != null && String(r.appeal_id) === raw) return true
      return false
    }).slice(0, 25)
  }

  $scope.jumpToSearchResult = (rec) => {
    $scope.caseSearch.results = []
    $scope.caseSearch.term = ''
    if (!rec.hearing_date) return
    const m = moment(rec.hearing_date)
    $scope.selectDay({
      inMonth: true,
      hearingCount: 1,
      date: m,
    })
  }

  $scope.bulkApplyType = (val) => {
    ($scope.addHearingDatesModal.matchedRecords || []).forEach(r => r.prop_type = val)
  }
  $scope.bulkApplyHearingDate = (val) => {
    ($scope.addHearingDatesModal.matchedRecords || []).forEach(r => r.hearing_date = val)
  }
  $scope.bulkApplyAuthCad = (val) => {
    ($scope.addHearingDatesModal.matchedRecords || []).forEach(r => r.auth_cad = !!val)
  }

  $scope.matchToAppeals = async () => {
    const m = $scope.addHearingDatesModal
    if (!m.county || !m.pastedCodes) return

    // Split paste on any whitespace, comma, semicolon, tab; dedupe and trim.
    const accounts = Array.from(new Set(
      m.pastedCodes
        .split(/[\s,;]+/)
        .map(s => s.trim())
        .filter(s => s.length > 0)
    ))

    if (accounts.length === 0) {
      m.matched = false
      m.matchedRecords = []
      m.unmatchedAccounts = []
      safeApply($scope)
      return
    }

    const result = await caseManagementService.matchAppealsByCadAccounts({
      tax_year: $scope.tax_year,
      cad_code: m.county.cad_code,
      cad_accounts: accounts,
    })

    if (result.data.success) {
      const payload = result.data.data || {}
      const matched = payload.matched || []
      const existing = payload.existing || []
      const matchedByAccount = new Map(matched.map(r => [String(r.cad_account), r]))
      const existingByAccount = new Map(existing.map(r => [String(r.cad_account), r]))
      const user = systemService.getUserObj() || {}
      const userName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim() || 'Unknown'
      const source = `${userName} - Manual Entry`

      m.matchedRecords = accounts.map(account => {
        const hit = matchedByAccount.get(String(account))
        const exists = existingByAccount.get(String(account))
        return {
          county: m.county.county,
          cad_code: m.county.cad_code,
          cad_account: account,
          appeal_id: hit ? hit.appeal_id : null,
          prop_id: hit ? hit.prop_id : null,
          prop_type: hit && (hit.prop_type === 'COM' || hit.prop_type === 'RES') ? hit.prop_type : 'RES',
          hearing_date: null,
          auth_cad: true,
          source: source,
          existing_id: exists ? exists.id : null,
        }
      })
      m.matched = true
    } else {
      console.log('matchToAppeals failed :>> ', result.data.error)
      m.matchedRecords = []
      m.matched = false
    }
    safeApply($scope)
  }

  $scope.notesModal = { rec: null, text: '' }

  $scope.openNotes = (rec) => {
    $scope.notesModal = { rec: rec, text: rec.notes || '' }
    const modal = new bootstrap.Modal(document.getElementById('notesModal'))
    modal.show()
  }

  $scope.saveNotes = async () => {
    const rec = $scope.notesModal.rec
    if (!rec || !rec.id) return
    const text = ($scope.notesModal.text || '').trim()
    const result = await caseManagementService.updateNotes({
      id: rec.id,
      cad_code: rec.cad_code,
      cad_account: rec.cad_account,
      notes: text,
    })
    if (result.data.success) {
      rec.notes = text || null
      // Match by composite identity (id + cad_code + cad_account) since `id` alone
      // is not unique in z_case_management — the PK is (id, cad_code, agent).
      const src = ($scope.caseData || []).find(r =>
        r.id === rec.id && r.cad_code === rec.cad_code && r.cad_account === rec.cad_account
      )
      if (src) src.notes = rec.notes
      const modalEl = document.getElementById('notesModal')
      bootstrap.Modal.getInstance(modalEl).hide()
    } else {
      console.log('updateNotes failed :>> ', result.data.error)
    }
    safeApply($scope)
  }

  $scope.saveHearingDate = async (rec) => {
    if (!rec || !rec.id) return
    const formatted = rec.hearing_date ? moment(rec.hearing_date).format('YYYY-MM-DD HH:mm:ss') : null
    const result = await caseManagementService.updateHearingDate({
      id: rec.id,
      cad_code: rec.cad_code,
      cad_account: rec.cad_account,
      hearing_date: formatted,
    })
    if (result.data.success) {
      const src = ($scope.caseData || []).find(r =>
        r.id === rec.id && r.cad_code === rec.cad_code && r.cad_account === rec.cad_account
      )
      if (src) src.hearing_date = formatted
      buildCalendarMonths()
    } else {
      console.log('updateHearingDate failed :>> ', result.data.error)
    }
    safeApply($scope)
  }

  $scope.bulkAgentSelection = ''

  $scope.bulkAssignAgent = async (agentId) => {
    // Placeholder "Assign all to…" is the empty string and should no-op.
    if (agentId === '' || agentId === undefined) {
      $scope.bulkAgentSelection = ''
      safeApply($scope)
      return
    }
    const visible = ($scope.selectedDayRecords || []).filter($scope.dayRecordsFilter)
    if (visible.length === 0) {
      $scope.bulkAgentSelection = ''
      safeApply($scope)
      return
    }
    const resolvedAgentId = (agentId === '__CLEAR__') ? null : parseInt(agentId, 10)
    const payload = {
      agent: resolvedAgentId,
      records: visible.map(r => ({ id: r.id, cad_code: r.cad_code, cad_account: r.cad_account })),
    }
    const result = await caseManagementService.bulkUpdateCaseAgent(payload)
    if (result.data.success) {
      const agent = resolvedAgentId ? ($scope.cadAgents || []).find(a => a.id === resolvedAgentId) : null
      const agentName = agent ? agent.name : null
      visible.forEach(rec => {
        rec.agent = resolvedAgentId
        rec.agent_name = agentName
        const src = ($scope.caseData || []).find(r =>
          r.id === rec.id && r.cad_code === rec.cad_code && r.cad_account === rec.cad_account
        )
        if (src) {
          src.agent = resolvedAgentId
          src.agent_name = agentName
        }
      })
      if ($scope.dayAgentList && $scope.dayAgentList.length > 0) {
        const counts = {}
        let unassigned = 0
        $scope.selectedDayRecords.forEach(r => {
          if (r.agent) counts[r.agent] = (counts[r.agent] || 0) + 1
          else unassigned++
        })
        $scope.dayAgentList.forEach(a => {
          a.count = (a.id === null) ? unassigned : (counts[a.id] || 0)
        })
      }
      buildCalendarMonths()
    } else {
      console.log('bulkUpdateCaseAgent failed :>> ', result.data.error)
    }
    $scope.bulkAgentSelection = ''
    safeApply($scope)
  }

  $scope.saveCaseAgent = async (rec) => {
    if (!rec || !rec.id) return
    const agentId = (rec.agent === '' || rec.agent === undefined) ? null : rec.agent
    const result = await caseManagementService.updateCaseAgent({
      id: rec.id,
      cad_code: rec.cad_code,
      cad_account: rec.cad_account,
      agent: agentId,
    })
    if (result.data.success) {
      const agent = agentId ? ($scope.cadAgents || []).find(a => a.id === agentId) : null
      rec.agent = agentId
      rec.agent_name = agent ? agent.name : null
      const src = ($scope.caseData || []).find(r =>
        r.id === rec.id && r.cad_code === rec.cad_code && r.cad_account === rec.cad_account
      )
      if (src) {
        src.agent = rec.agent
        src.agent_name = rec.agent_name
      }
      // Recompute day-agent counts so the filter dropdown stays accurate.
      if ($scope.dayAgentList && $scope.dayAgentList.length > 0) {
        const counts = {}
        let unassigned = 0
        $scope.selectedDayRecords.forEach(r => {
          if (r.agent) counts[r.agent] = (counts[r.agent] || 0) + 1
          else unassigned++
        })
        $scope.dayAgentList.forEach(a => {
          a.count = (a.id === null) ? unassigned : (counts[a.id] || 0)
        })
      }
      buildCalendarMonths()
    } else {
      console.log('updateCaseAgent failed :>> ', result.data.error)
    }
    safeApply($scope)
  }

  function buildCalendarMonths() {
    updateFooterStats()
    $scope.calendarMonths = []
    const agentFilter = $scope.currentCadAgent ? $scope.currentCadAgent.id : null
    const records = applyGlobalFilters($scope.caseData || []).filter(r => {
      if (!r.hearing_date) return false
      if (agentFilter !== null && r.agent !== agentFilter) return false
      return true
    })
    if (records.length === 0) return

    const dates = records.map(r => moment(r.hearing_date))
    const minDate = moment.min(dates).startOf('month')
    const maxDate = moment.max(dates).startOf('month')

    // Build: countsByDay[YYYY-MM-DD] = { 'Collin': { com: 5, res: 10, total: 15 }, ... }
    const countsByDay = {}
    // assignedByDay[YYYY-MM-DD] = { total, assigned }
    const assignedByDay = {}
    records.forEach(r => {
      const key = moment(r.hearing_date).format('YYYY-MM-DD')
      const county = r.county_name || r.cad_code || 'Unknown'
      if (!countsByDay[key]) countsByDay[key] = {}
      if (!countsByDay[key][county]) countsByDay[key][county] = { com: 0, res: 0, total: 0 }
      const bucket = countsByDay[key][county]
      if (r.prop_type === 'COM') bucket.com++
      else if (r.prop_type === 'RES') bucket.res++
      bucket.total++

      if (!assignedByDay[key]) assignedByDay[key] = { total: 0, assigned: 0 }
      assignedByDay[key].total++
      if (r.agent) assignedByDay[key].assigned++
    })

    const cursor = minDate.clone()
    while (cursor.isSameOrBefore(maxDate)) {
      const monthStart = cursor.clone().startOf('month')
      const gridStart = monthStart.clone().startOf('week')

      const weeks = []
      let day = gridStart.clone()
      // Always render 6 week rows so every calendar has the same height
      const finalEnd = gridStart.clone().add(6 * 7 - 1, 'day')
      while (day.isSameOrBefore(finalEnd)) {
        const week = []
        for (let i = 0; i < 7; i++) {
          const key = day.format('YYYY-MM-DD')
          const countyMap = countsByDay[key] || {}
          const pills = Object.keys(countyMap).sort().map(name => ({
            county: name,
            com: countyMap[name].com,
            res: countyMap[name].res,
            total: countyMap[name].total,
          }))
          const totals = pills.reduce((acc, p) => {
            acc.com += p.com
            acc.res += p.res
            acc.total += p.total
            return acc
          }, { com: 0, res: 0, total: 0 })
          const assignmentInfo = assignedByDay[key] || { total: 0, assigned: 0 }
          week.push({
            date: day.clone(),
            day: day.date(),
            inMonth: day.month() === monthStart.month(),
            hearingCount: totals.total,
            pills: pills,
            totals: totals,
            allAssigned: assignmentInfo.total > 0 && assignmentInfo.assigned === assignmentInfo.total,
          })
          day.add(1, 'day')
        }
        weeks.push(week)
      }

      $scope.calendarMonths.push({
        label: monthStart.format('MMMM YYYY'),
        weeks: weeks,
      })
      cursor.add(1, 'month')
    }
  }

  const tableID = '#hearingPortalTable'

  let table

  let taxYearResults = await systemService.functionCall({ type: "getCurrentTaxYear" })
  $scope.tax_year = taxYearResults.data.data

  let cadAgentResults = await systemService.functionCall({ type: "getCADAgents" })
  $scope.cadAgents = cadAgentResults.data.data

  let countyListResults = await caseManagementService.loadCaseDataCounties({ tax_year: $scope.tax_year })
  $scope.countyList = countyListResults.data.data

  let allCountiesResults = await systemService.functionCall({ type: "countyList", active_only: false })
  $scope.allCounties = allCountiesResults.data.data

  let caseDataResults = await caseManagementService.loadCaseData({ tax_year: $scope.tax_year })
  $scope.caseData = caseDataResults.data.data
  buildCalendarMonths()

  console.log('$scope.tax_year :>> ', $scope.tax_year)
  console.log('$scope.allCounties :>> ', $scope.allCounties)
  console.log('$scope.cadAgents :>> ', $scope.cadAgents)
  console.log('$scope.countyList :>> ', $scope.countyList)
  console.log('$scope.caseData :>> ', $scope.caseData)

  $scope.refreshing = false
  safeApply($scope)

  // Convert vertical wheel into horizontal scroll on the calendar strip.
  // Uses delegation on the panel so it survives the ng-if toggle between calendar/table views.
  const wrapperEl = document.getElementById('case-management-wrapper')
  if (wrapperEl) {
    wrapperEl.addEventListener('wheel', (e) => {
      const calendarEl = document.getElementById('calendarView')
      if (!calendarEl || !calendarEl.contains(e.target)) return
      if (e.deltaY === 0) return
      // Let the per-day pill list handle vertical scrolling when the cursor is inside one.
      if (e.target.closest('.pill-list')) return
      calendarEl.scrollLeft += e.deltaY
      e.preventDefault()
    }, { passive: false })
  }


})